import { CopyableText } from "./CopyableText.jsx";
import { formatDateForCopy } from "./date-copy.js";

export function CopyableDate({
  as = "button",
  children,
  className = "",
  fallback = null,
  value,
}) {
  const copyValue = formatDateForCopy(value);
  if (!copyValue) return children ?? fallback;

  return (
    <CopyableText
      as={as}
      className={`suite-copyable-date ${className}`.trim()}
      copiedMessage="Fecha copiada"
      errorMessage="No pudimos copiar la fecha"
      label="fecha"
      value={copyValue}
    >
      {children ?? copyValue}
    </CopyableText>
  );
}
